import type { PropsWithChildren, ReactNode } from 'react';

type MainProps = PropsWithChildren<{
  meta: ReactNode;
}>;

const Main = ({ meta, children }: MainProps) => (
  <>
    {meta}
    {children}
  </>
);

export default Main;
